import { TkGetCode } from "../../../utils/TkGetCode";
import {
  HalfYearExtensionReason,
  YesOrNoFlug,
} from "../../../assets/data/Constants";

/**
 * 育休テーブルを作成する
 * @param res
 * @returns infoBodyList
 */
function funInfoBodyList(res: any) {
  const infoBodyList: any[] = [];
  for (let i in res) {
    const data = [
      {
        children: res[i].birthday, //出産日
      },
      {
        children: res[i].startDate, //育児休業開始日
      },
      {
        children: res[i].endDate, //育児休業終了日
      },
      {
        children: TkGetCode(YesOrNoFlug, res[i].papaMamaPlus), //パパママ育休プラス
      },
      {
        children: TkGetCode(
          HalfYearExtensionReason,
          res[i].halfyearExtendReason
        ), //半年延長の理由
      },
      {
        children: TkGetCode(YesOrNoFlug, res[i].papaChildcareLeaveFlg), //産後パパ育休フラグ
      },
    ];
    infoBodyList.push(data);
  }

  return infoBodyList;
}

/**
 * 移動履歴を作成する
 * @param res
 * @returns transferHistoryBodyList
 */
function funTransferHistoryList(res: any) {
  const transferHistoryBodyList: any[] = [];
  for (let i in res) {
    const data = {
      leftText:
        (res[i].sTransferDate ?? "") + "～" + (res[i].transferDate ?? ""),
      rightText: (res[i].bFacilityNo ?? "") + ":" + (res[i].facilityName ?? ""),
    };
    transferHistoryBodyList.push(data);
  }

  return transferHistoryBodyList;
}

export { funInfoBodyList, funTransferHistoryList };
